<template>
  <section class="merge-request-layout">
    <div class="container">
      <div class="row">
        <div class="col-12">
          <router-view />
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  // eslint-disable-next-line vue/match-component-file-name
  name: 'MergeRequestLayout'
};
</script>
